import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import { bugsnagNotify } from 'utilities/bugsnag';

import ErrorMessage from '../error_message';

interface Props {}

const ActivityPanel: React.FC<Props> = (props) => {
  const logError = (error: Error, info?: { componentStack: string }) => {
    bugsnagNotify(error);
  };

  return (
    <ErrorBoundary fallback={<ErrorMessage />} onError={logError}>
      <div style={{ overflowY: 'scroll', overscrollBehavior: 'contain' }}>
        Activity Panel
      </div>
    </ErrorBoundary>
  );
};

export default ActivityPanel;
